import Vue from 'vue';
import * as Cookies from 'js-cookie';
import { globalStore } from '@/utils/global';

Vue.use(Cookies);

export const ACCESS_TOKEN = globalStore.token || Cookies.get('user-admin-token');
